<script lang="ts" setup>
import Repo from './Repo.vue';
import HotTag from './HotTag.vue';
import Subscription from './Subscription.vue';
import CommunityCard from './CommunityCard.vue';

const props =  defineProps({
  isTag: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="flex justify-between py-80">
    <div class="w-792">
      <Repo />
    </div>
    <div class="w-376">
      <CommunityCard />
      <HotTag v-if="props.isTag" />
      <Subscription />
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
